module.exports = __webpack_public_path__ + "static/media/StrategicReports.15341bd5.pdf";